import react from 'react'

export default function Profile(){

    return(<div>this is profile page</div>)
}